import { createAction } from 'redux-actions'

export const SET_APP_SETTINGS = 'SET_APP_SETTINGS'
export const setAppSettings = createAction(SET_APP_SETTINGS)



// WEBPACK FOOTER //
// ./actions/app.js